module.exports = __webpack_public_path__ + "img/softgrove-8.332068e7.jpeg";